export function slugify(id: string | number, storeName: string): string {
  const safeName = (storeName ?? 'store')
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\u0600-\u06FF\w\-]+/g, '')
    .replace(/\-\-+/g, '-');

  return `${safeName}/${id}`;
}

export function generateSlug(id: string | number, name: string): string {
  const safeName = (name ?? 'product')
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\u0600-\u06FF\w\-]+/g, '')
    .replace(/\-\-+/g, '-');

  return `${id}~${safeName}`;
}

export function extractIdFromSlug(slug: string): string {
  const index = slug.indexOf('-');
  return index === -1 ? slug : slug.substring(0, index);
}

export function extractIdAndName(slug: string): { id: string; name: string } {
  const [id, ...rest] = slug.split('~');
  return { id, name: rest.join('~') }; // لو الاسم فيه |
}

export function extractNameFromSlug(slug: string): string {
  const index = slug.indexOf('-');
  return index === -1 ? slug : slug.substring(index + 1);
}

export function safeName(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\u0600-\u06FF\w-]+/g, '')
    .replace(/--+/g, '-');
}
